module.exports = __webpack_public_path__ + "img/face-nose-steam.cc554c03.svg";